<template>
    <div id="main">
        <sek-header class="is-scrolled"/>
        <div id="wrapper">
            <section id="parceiro">
                <h2 
                    class="parceiro-title text-center white--text mb-0">
                    Seja Parceiro
                </h2>
                <h5 class="parceiro-subtitle white--text text-center">
                    cadastro de assessorados
                </h5>
            </section>
        </div>
        <sek-footer class="parceiros-footer">
            <container class="mb-9">
                <v-row>
                    <v-col
                        sm="12"
                        md="6"
                        lg="6">
                        <div class="box">
                            <h3 class="title">CADASTRO</h3>

                            <div class="round"></div>

                            <h5 class="subtitle">Cadastro de Assessorado</h5>
                            <p class="white--text">Consultoria especializada no suporte técnico e comercial, específica para corretores de seguros.</p>

                            <div class="d-flex">
                                <v-btn
                                    @click="goTo({ name: 'cadastro'})"
                                    class="mx-auto parceiros-btn"
                                    color="#ff8800">
                                    Cadastrar
                                </v-btn>

                            </div>

                        </div>
                    </v-col>
                    <v-col
                        sm="12"
                        md="6"
                        lg="6">
                        <div class="box">
                            <h3 class="title">LOGIN - Em breve</h3>

                            <div class="round"></div>

                            <h5 class="subtitle">Login de Assessorado</h5>
                            <p class="white--text">Consultoria especializada no suporte técnico e comercial, específica para corretores de seguros.</p>

                            <div class="d-flex">
                                <v-btn
                                    class="mx-auto parceiros-btn"
                                    color="#ff8800">
                                    Login
                                </v-btn>

                            </div>

                        </div>
                    </v-col>
                </v-row>
            </container>
        </sek-footer>
    </div>
</template>

<script>
import Header from '../../components/base/Header.vue'
import Footer from '../../components/base/Footer.vue'

export default {
    components: {
        'sek-header': Header,
        'sek-footer': Footer
    },
    data() {
        return {
            password: "",
            email: ""
        }
    },
    methods: {
        goTo(opts) {
            this.$router.push(opts)
        }
    },
}
</script>

<style lang="scss">
#main {
    height: 100%;
    display: flex;
    flex-direction: column;

    #wrapper {
        width: 100%;
        height: 100%;

        #parceiro {
            min-height: 350px;
            background-image: url('~@/assets/images/sek-section-bg.png');
            background-position: center 20%;
            background-size: cover;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .parceiro-title {
                font-size: 45px;
                line-height: 45px;
                margin-top: 40px;
            }

            .parceiro-subtitle {
                font-size: 20px;
                letter-spacing: 5px;
                font-weight: 300;
                margin-bottom: 30px;
            }
        }
    }

    .parceiros-footer {

        .box {
            transition: all 0.2s ease;
            background: rgba(20,21,23,1);
            text-align: center;
            max-width: 400px;

            &:hover {
                box-shadow: 0px 0px 10px 5px #ff8801;
            }

            padding: 20px;

            .title {
                text-align: left;
                font-size: 30px;
                padding-left: 5px;
                margin-top: -15px;
                margin-left: -15px;
            }
            .subtitle {
                color: #ff8801;
                font-size: 20px;
            }

            .round {
                width: 80px;
                height: 80px;
                background: black;
                margin: 10px auto;
                border-radius: 50%;
            }

            .parceiros-btn {
                border-radius: 50px;
                color: white;
                margin-top: 10px;
                text-transform: capitalize;
                min-width: 150px;
            }


        }
    }

    // @media screen and (max-width: 480px) {
    //     #wrapper {
    //         padding: 108px 28px 28px 28px;
    //     }
    // }
}
</style>